import { requestManager } from '../../requestManager';

import { API_PATH } from '../../config/config';

class Confirmation {
  /**
   * 受付登録
   * @param {string} lgCd 市町村コード
   * @param {object} receptInfo 受付情報
   * @param {Array} business 用件
   * @param {Array} recItems 申請項目
   * @param {object} reserveInfo 予約情報
   * @param {string} userCd 利用者コード
   * @param {number} rsvSetId 予約設定ID
   * @param {object} place 予約施設情報
   * @param {boolean} useHome 自宅を使用するかどうか
   * @param {number} rsvFlag 予約フラグ
   * @return {Promise<Boolean>} 登録成否
   */
  registerReception = async (
    lgCd,
    receptInfo,
    business,
    recItems,
    reserveInfo,
    userCd,
    rsvSetId,
    place,
    useHome,
    rsvFlag
  ) => {
    const result = await requestManager.post(`${API_PATH}/confirmation/c`, {
      lgCd,
      receptInfo,
      business,
      recItems,
      reserveInfo,
      userCd,
      rsvSetId,
      place,
      useHome,
      rsvFlag,
    });

    return result.data;
  };

  /**
   * 予約設定マスタ検索
   * @param {number} rsvSetId 予約設定のID
   * @returns {int} 同時予約可能数
   */
  searchReserveSetting = async (rsvSetId = null) => {
    const filter = { rsv_set_id: rsvSetId, enable: true };
    const params = { filter };
    const result = await requestManager.get(`${API_PATH}/confirmation/r/reserve-setting`, params);
    return result.data;
  };

  /**
   * 同一アドレス、電話番号による予約数を数える
   * @param {*} rsvSetId 予約設定ID
   * @param {*} sendType 送信方法
   * @param {*} mailAddress メールアドレス
   * @param {*} telNum 電話番号
   * @returns 現在の予約数
   */
  searchReserveCount = async (rsvSetId, sendType, mailAddress, telNum) => {
    const filter = {
      rsvSetId,
      sendType,
      mailAddress,
      telNum,
      enable: true,
    };
    const params = { filter };
    const result = await requestManager.get(`${API_PATH}/confirmation/r/reserve-count`, params);
    return result.data;
  };
}

const instance = new Confirmation();
instance.Constructor = Confirmation;

export default instance;
